export default __webpack_public_path__ + "static/media/button_align_left.bf9c48fc.svg";